import { useEffect, useMemo, useState } from 'react';
import {
  fetchPersonalization,
  fetchSmartMatchConfig,
  getSearchIntent,
  inferIntentFromSearchParams,
  scorePropertyMatch,
  scoreProperties,
} from '../utils/smartMatchScore';

export const useSmartMatch = (properties = [], overrideIntent = null) => {
  const [personalization, setPersonalization] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    Promise.all([fetchSmartMatchConfig(), fetchPersonalization()]).then(([, pers]) => {
      if (!cancelled) {
        setPersonalization(pers);
        setReady(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const intent = useMemo(
    () => overrideIntent || getSearchIntent(),
    [overrideIntent, ready]
  );

  const scoredProperties = useMemo(() => {
    if (!properties.length) return [];
    return scoreProperties(properties, intent, personalization || {});
  }, [properties, intent, personalization]);

  return { intent, personalization, scoredProperties, ready, scoreOne: (p, customIntent) => scorePropertyMatch(p, customIntent || intent, personalization || {}) };
};

export const useSmartMatchIntent = (searchParams) =>
  useMemo(() => inferIntentFromSearchParams(searchParams || {}), [searchParams]);

export default useSmartMatch;
